import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GetReviewDataPipe } from './get-review-data.pipe';
import { IsGmbEnabledPipe } from './is-gmb-enabled.pipe';
import { IsFacebookEnabledPipe } from './is-facebook-enabled.pipe';
import { IsIntegratedWithFacebookPipe } from './is-integrated-with-facebook.pipe';
import { IsIntegratedWithGmbPipe } from './is-integrated-with-gmb.pipe';
import { IsFacebookPipe } from './is-facebook.pipe';
import { IsGooglePipe } from './is-google.pipe';
import { IsZillowPipe } from './is-zillow.pipe';
import { ReviewTargetErrorMessagePipe } from './review-target-error-message.pipe';
import { SomeIntegrationEnabledPipe } from './some-integration-enabled.pipe';
import { ShortAddressPipe } from './short-address.pipe';
import { ShortNumberPipe } from './short-number.pipe';
import { ReversePipe } from './reverse.pipe';
import { RgbToHexPipe } from './rgb-to-hex.pipe';
import { SumPipe } from './sum.pipe';
import { MaxPipe } from './max.pipe';
import { ZillowCallActionUrlSuffix } from './zillow-call-action-url-suffix.pipe';

const PIPES = [
  GetReviewDataPipe,
  IsFacebookEnabledPipe,
  IsGmbEnabledPipe,
  IsIntegratedWithFacebookPipe,
  IsIntegratedWithGmbPipe,
  IsFacebookPipe,
  IsGooglePipe,
  IsZillowPipe,
  ReversePipe,
  ReviewTargetErrorMessagePipe,
  RgbToHexPipe,
  ShortAddressPipe,
  ShortNumberPipe,
  SomeIntegrationEnabledPipe,
  SumPipe,
  MaxPipe,
  ZillowCallActionUrlSuffix,
];

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ...PIPES
  ],
  exports: [
    ...PIPES
  ]
})
export class PipesModule { }
